export default __webpack_public_path__ + "static/media/am.aebf3383.svg";